import { ApiService } from "@/api";

export const deleteGroup = (groupId: string) => {
  return ApiService.baseAction("group/" + groupId, {}, "delete");
};
